import { createSelector } from 'reselect';
import HandlerMonitoringColumns from '../../containers/HandlerMonitoringColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.HANDLER_MONITORING.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.HANDLER_MONITORING.isLoading;

export const getData =
  ReportDefinitions.HANDLER_MONITORING.getDataFunction();

export const getColumns =
  createSelector(getData, HandlerMonitoringColumns);
